export class VehicleInspectionIntervals {
  id: number = -1;
  name: string = '';
  number:number = -1;
  unit: string = null;
  unitAbbrev: string = null;
  entity: string = null;
  colour: string = '';
}
